import Vue from "vue";
import Vuex from 'vuex'
import ShoppingCart from "./shopping-cart";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

const store = new Vuex.Store({
    plugins: [createPersistedState()],
    modules: {
        cartModule: ShoppingCart
    }
})

export default store;
